import toggleTodo from './toggleTodo';
export default function toggleSelectedTodos(editor, checked) {
  var selection = editor.value.selection;
  var blocks = editor.value.document.getLeafBlocksAtRange(selection);
  return blocks.reduce(function (memo, block) {
    return toggleTodo(memo, block, checked);
  }, editor);
}